import { useEffect } from 'react';
import Lenis from 'lenis';
import { Toaster } from './components/ui/sonner';
import GoldenDust from './components/GoldenDust';
import HeaderNav from './components/HeaderNav';
import HeroSection from './components/HeroSection';
import MarqueeRibbon from './components/MarqueeRibbon';
import FlipBookViewer from './components/FlipBookViewer';
import InfoSection from './components/InfoSection';
import EnrollmentForm from './components/EnrollmentForm';
import Footer from './components/Footer';
import { LangProvider } from './i18n';

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangProvider>
      <div className="relative min-h-screen bg-[#070e12] text-[#f4f1ea] font-body">
        <Toaster theme="dark" position="bottom-center" richColors />
        <div className="grain-overlay" />
        <GoldenDust />
        <HeaderNav />
        <main className="relative z-10">
          <HeroSection />
          <MarqueeRibbon />
          <FlipBookViewer />
          <EnrollmentForm />
          <InfoSection />
        </main>
        <Footer />
      </div>
    </LangProvider>
  );
}

export default App;
